(function () {
  if (window.__cartDrawerDiscountInit) return;
  window.__cartDrawerDiscountInit = true;

  var STORAGE_KEY = 'cart_drawer_discount_code';
  var OPEN_AFTER_POPUP_KEY = 'open_cart_drawer_after_popup';

  function getEls() {
    return {
      drawer: document.querySelector('cart-drawer'),
      input: document.getElementById('CartDrawer-DiscountCode'),
      btn: document.getElementById('CartDrawer-DiscountApply'),
      state: document.getElementById('CartDrawer-DiscountState'),
      code: document.getElementById('CartDrawer-DiscountStateCode'),
      removeBtn: document.getElementById('CartDrawer-DiscountRemove')
    };
  }

  function showAppliedState(code) {
    var els = getEls();
    if (!els.state || !els.code) return;

    els.state.classList.remove('hidden');
    els.state.classList.add('is-applied');
    els.code.textContent = code || '';
  }

  function hideAppliedState() {
    var els = getEls();
    if (!els.state || !els.code) return;

    els.state.classList.add('hidden');
    els.state.classList.remove('is-applied');
    els.code.textContent = '';
  }

  function syncDiscountState() {
    var storedCode = localStorage.getItem(STORAGE_KEY);

    var liquidStateEl = document.getElementById('CartDrawer-DiscountState');
    var liquidCodeEl = document.getElementById('CartDrawer-DiscountStateCode');

    var liquidCode = liquidCodeEl ? liquidCodeEl.textContent.trim() : '';
    var liquidIsApplied = !!(
      liquidStateEl &&
      liquidStateEl.classList.contains('is-applied') &&
      liquidCode
    );

    if (liquidIsApplied) {
      localStorage.setItem(STORAGE_KEY, liquidCode);
      showAppliedState(liquidCode);
      return;
    }

    if (storedCode) {
      showAppliedState(storedCode);
      return;
    }

    hideAppliedState();
  }

  async function refreshCartDrawer(options) {
    var opts = options || {};
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    var keepOpen = !!opts.keepOpen;
    var wasOpen = keepOpen || drawer.classList.contains('active');

    try {
      var res = await fetch(window.location.pathname + '?sections=cart-drawer', {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!res.ok) throw new Error('Failed to refresh drawer');

      var data = await res.json();
      var html = data['cart-drawer'];
      if (!html) return false;

      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('cart-drawer');
      var currentDrawer = document.querySelector('cart-drawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;

        if (wasOpen) {
          currentDrawer.classList.add('active');
        } else {
          currentDrawer.classList.remove('active');
        }
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));

      setTimeout(function () {
        syncDiscountState();
      }, 80);

      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    if (drawer) {
      drawer.classList.add('active');
      return true;
    }

    return false;
  }

  async function forceRevealCartAfterPopup() {
    await refreshCartDrawer({ keepOpen: true });

    syncDiscountState();

    setTimeout(function () {
      openCartDrawer();
      syncDiscountState();
    }, 120);

    setTimeout(function () {
      syncDiscountState();
    }, 300);
  }

  async function revealCartAfterPopup() {
    var openAfterPopup = sessionStorage.getItem(OPEN_AFTER_POPUP_KEY);
    if (openAfterPopup !== '1') return;

    sessionStorage.removeItem(OPEN_AFTER_POPUP_KEY);
    await forceRevealCartAfterPopup();
  }

  async function applyDiscountCode() {
    var els = getEls();
    if (!els.input || !els.btn) return;

    var code = els.input.value.trim();
    if (!code) return;

    els.btn.disabled = true;
    els.btn.textContent = 'APPLYING...';

    try {
      var res = await fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!res.ok) {
        throw new Error('Discount request failed');
      }

      localStorage.setItem(STORAGE_KEY, code);

      await refreshCartDrawer({ keepOpen: true });
      syncDiscountState();
    } catch (err) {
      console.error(err);
      hideAppliedState();
    } finally {
      var fresh = getEls();
      if (fresh.btn) {
        fresh.btn.disabled = false;
        fresh.btn.textContent = 'APPLY';
      }
    }
  }

  function removeDiscountCode() {
    localStorage.removeItem(STORAGE_KEY);

    var els = getEls();
    if (els.input) {
      els.input.value = '';
    }

    hideAppliedState();
  }

  async function handleOpenAfterPopup() {
    await revealCartAfterPopup();
  }

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('#CartDrawer-DiscountApply');
    if (applyBtn) {
      applyDiscountCode();
      return;
    }

    var removeBtn = e.target.closest('#CartDrawer-DiscountRemove');
    if (removeBtn) {
      removeDiscountCode();
    }
  });

  document.addEventListener('keydown', function (e) {
    var input = e.target.closest('#CartDrawer-DiscountCode');
    if (!input) return;

    if (e.key === 'Enter') {
      e.preventDefault();
      applyDiscountCode();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncDiscountState();
    handleOpenAfterPopup();
  });

  document.addEventListener('shopify:section:load', function () {
    syncDiscountState();
  });

  document.addEventListener('cart:refresh', function () {
    syncDiscountState();
  });

  document.addEventListener('cart:updated', function () {
    syncDiscountState();
  });

  document.addEventListener('popup:reveal_cart', function () {
    forceRevealCartAfterPopup();
  });

  setTimeout(function () {
    syncDiscountState();
    handleOpenAfterPopup();
  }, 300);
})();